import ConstraintBlock from "./ConstraintBlock";
import ConstraintTableHeader from "./ConstraintTableHeader";
import AddConstraintToggle from "./AddConstraintToggle";
import { Constraint } from "../../types/constraint";
import { useAppDispatch } from "../../store/hooks";
import ConstraintService from "../../service/constraintService";
import { removeConstraintFromEmployee } from "../../store/constraint";
import ConstraintRow from "./ConstraintRow";
import { isConstraintActive } from "../../utils/arrayUtils";

const EmployeeConstraintContent = ({
  employeeRef,
  constraints,
  showActiveOnly,
}: {
  employeeRef: string;
  constraints: Constraint[];
  showActiveOnly: boolean;
}) => {
  const dispatch = useAppDispatch();

  const visibleConstraints = showActiveOnly
    ? constraints.filter((c) => isConstraintActive(c.startDate, c.endDate))
    : constraints;

  const handleDelete = async (
    constraintId: number,
    isCategoryConstraint: boolean,
  ) => {
    try {
      await ConstraintService.deleteEmployeeConstraint(
        constraintId,
        isCategoryConstraint,
        dispatch,
      );
      dispatch(removeConstraintFromEmployee({ employeeRef, constraintId }));
    } catch {
      // error notification handled in service
    }
  };

  return (
    <div className="p-[var(--spacing-sm)] flex-col justify-start">
      <ConstraintBlock>
        {visibleConstraints.length > 0 && <ConstraintTableHeader />}
        {visibleConstraints.map((constraint) => (
          <ConstraintRow
            key={constraint.id}
            constraint={constraint}
            employeeRef={employeeRef}
            existingConstraints={constraints}
            onDelete={() =>
              handleDelete(constraint.id, constraint.isCategoryConstraint)
            }
          />
        ))}
        {/* existingConstraints is the full list, not visibleConstraints: showActiveOnly filters
            constraints out of view, but a hidden constraint still occupies its target — passing
            the filtered list would offer the duplicate straight back. */}
        <AddConstraintToggle
          employeeRef={employeeRef}
          existingConstraints={constraints}
        />
      </ConstraintBlock>
    </div>
  );
};

export default EmployeeConstraintContent;
